import { render, staticRenderFns } from "./CreateRoomDialog.vue?vue&type=template&id=42b8597a"
import script from "./CreateRoomDialog.vue?vue&type=script&lang=js"
export * from "./CreateRoomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports